const getPatientAddress = ({ patient, value, billing = false }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  const address = billing ? patient['Billing Address Information'] : patient['Address Information'];
  if (address && address.Apt) {
    return `${address.Street} ${address.Apt}`.toUpperCase();
  } else if (address && address.Street) {
    return address.Street.toUpperCase();
  }
  return null;
};

export default getPatientAddress;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientAddress.js